const SET_PRODUCT = (state, payload) => {
    state.product = [];
    state.product = payload;
}
const CLEAR_PRODUCT = (state) => {
    state.product = [];
}

const SET_PRODUCTS = (state, payload) => {
    state.products = [];
    state.products = payload;
}
const CLEAR_PRODUCTS = (state) => {
    state.products = [];
}

const SET_PRODUCT_TYPES = (state, payload) => {
    state.product_types = [];
    state.product_types = payload;
}
const CLEAR_PRODUCT_TYPES = (state) => {
    state.product_types = [];
}

const SET_SUBSCRIPTION = (state, payload) => {
    state.subscription = [];
    state.subscription = payload;
}
const CLEAR_SUBSCRIPTION = (state) => {
    state.subscription = [];
}

const SET_CURRENT_SUBSCRIPTION = (state, payload) => {
    state.current_subscription = [];
    state.current_subscription = payload;
}
const CLEAR_CURRENT_SUBSCRIPTION = (state) => {
    state.current_subscription = [];
}

const SET_OTHER_SUBSCRIPTION = (state, payload) => {
    state.other_subscription = [];
    state.other_subscription = payload;
}
const CLEAR_OTHER_SUBSCRIPTION = (state) => {
    state.other_subscription = [];
}

const SET_PREVIOUS_ITEM_SUBSCRIPTIONS = (state, payload) => {
    state.previous_item_subscriptions = [];
    state.previous_item_subscriptions = payload;
}
const CLEAR_PREVIOUS_ITEM_SUBSCRIPTIONS = (state) => {
    state.previous_item_subscriptions = [];
}

const SET_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS = (state, payload) => {
    state.previous_any_item_subscriptions = [];
    state.previous_any_item_subscriptions = payload;
}
const CLEAR_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS = (state) => {
    state.previous_any_item_subscriptions = [];
}

const SET_SUBSCRIPTIONS = (state, payload) => {
    state.subscriptions = [];
    state.subscriptions = payload;
}
const CLEAR_SUBSCRIPTIONS = (state) => {
    state.subscriptions = [];
}

const SET_CHOSEN_ITEM = (state, payload) => {
    state.chosen_item = '';
    state.chosen_item = payload;
}
const CLEAR_CHOSEN_ITEM = (state) => {
    state.chosen_item = '';
}

const SET_ITEM_TRANSACTION_HISTORY = (state, payload) => {
    state.item_transaction_history = '';
    state.item_transaction_history = payload;
}
const CLEAR_ITEM_TRANSACTION_HISTORY = (state) => {
    state.item_transaction_history = [];
}

const SET_RECEIPT_ITEM_INFO = (state, payload) => {
    state.receipt_item_info = '';
    state.receipt_item_info = payload;
}

const CLEAR_RECEIPT_ITEM_INFO = (state) => {
    state.receipt_item_info = [];
}

const SET_RECEIPT_INFO = (state, payload) => {
    state.receipt_info = '';
    state.receipt_info = payload;
}

const CLEAR_RECEIPT_INFO = (state) => {
    state.receipt_info = [];
}

const SET_RECEIPT_STATUS = (state, payload) => {
    state.receipt_status = '';
    state.receipt_status = payload;
}

const CLEAR_RECEIPT_STATUS = (state) => {
    state.receipt_status = [];
}

const SET_ACTIVE_FREE_MONTH = (state, payload) => {
    state.active_free_month = '';
    state.active_free_month = payload;
}

const CLEAR_ACTIVE_FREE_MONTH = (state) => {
    state.active_free_month = [];
}

const CLEAR_STATES = (state) => {
    state.product = [];
    state.products = [];
    state.product_types = [];
    state.subscription = [];
    state.current_subscription = [];
    state.other_subscription = [];
    state.previous_item_subscriptions = [];
    state.previous_any_item_subscriptions = [];
    state.subscriptions = [];
    //state.chosen_item = ''; //Exclude this as this will be used on other page
    state.item_transaction_history = '';
    state.receipt_item_info = '';
    state.receipt_info = '';
    state.receipt_status = '';
    state.active_free_month = '';
}

export {
    SET_PRODUCT,
    CLEAR_PRODUCT,
    SET_PRODUCTS,
    CLEAR_PRODUCTS,
    SET_PRODUCT_TYPES,
    CLEAR_PRODUCT_TYPES,
    SET_SUBSCRIPTION,
    CLEAR_SUBSCRIPTION,
    SET_CURRENT_SUBSCRIPTION,
    CLEAR_CURRENT_SUBSCRIPTION,
    SET_OTHER_SUBSCRIPTION,
    CLEAR_OTHER_SUBSCRIPTION,
    SET_PREVIOUS_ITEM_SUBSCRIPTIONS,
    CLEAR_PREVIOUS_ITEM_SUBSCRIPTIONS,
    SET_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS,
    CLEAR_PREVIOUS_ANY_ITEM_SUBSCRIPTIONS,
    SET_SUBSCRIPTIONS,
    CLEAR_SUBSCRIPTIONS,
    SET_CHOSEN_ITEM,
    CLEAR_CHOSEN_ITEM,
    CLEAR_STATES,
    SET_ITEM_TRANSACTION_HISTORY,
    CLEAR_ITEM_TRANSACTION_HISTORY,
    SET_RECEIPT_ITEM_INFO,
    CLEAR_RECEIPT_ITEM_INFO,
    SET_RECEIPT_INFO,
    CLEAR_RECEIPT_INFO,
    SET_RECEIPT_STATUS,
    CLEAR_RECEIPT_STATUS,
    SET_ACTIVE_FREE_MONTH,
    CLEAR_ACTIVE_FREE_MONTH,
}
